import { cn } from "@roman/shared/utils";

export const Center = ({ children, className }: { children: React.ReactNode; className?: string }) => {
  return (
    <div className={cn("z-[999] flex h-screen w-screen items-center justify-center fixed inset-0", className)}>
      {children}
    </div>
  );
};
